import React from 'react'
import { Link } from 'react-router-dom'
import OpalHeading from '../../../opal/OpalHeading'
import Loading from '../../../molecules/Loading'
import FlexRow from '../../../molecules/FlexRow'
import { useFormattingContext } from '../../../organisms/FormattingProvider/FormattingContext'
import OpalCard from '../../../opal/OpalCard'
import { abundanceDesigner } from './Playground/playgroundApp'

function UserThreadList () {
  const { formatter } = useFormattingContext()
  const { data, isLoading } = abundanceDesigner.useListOwnedThreads()
  return (
    <OpalCard size='md'>
      <OpalHeading className='font-size-md'>Previous Threads</OpalHeading>
      {isLoading ? (
        <Loading />
      ) : (
        <div className='flex flex-col gap-md py-2'>
          {(data?.threads || []).map(t => (
            <Link to={`/denali-labs/abundance-designer/playground/${t.threadId}`} className='opal-card-sm opal-surface-default hover clickable' key={t.threadId}>
              <FlexRow className='justify-between'>
                <div>{t.name}</div>
                <div>{formatter(t.lastActivity || t.createdDate, 'localDateTime')}</div>
              </FlexRow>
            </Link>
          ))}
        </div>
      )}
    </OpalCard>
  )
}

export default UserThreadList
